import React from 'react'
import {Box, Typography, Card, Divider, Rating, Button, Grid} from "@mui/material";
import useStyles from "../../../../assets/styles/ProgramRatingStyles";
import Logo from '../../../../assets/images/dqCitizenshipLogo.png'
import {useHistory} from "react-router-dom";
import {APP_STATUS} from "../../../../utils/constants";
const DQRatingContentReport = ({ data, actions, options }) => {
    const history = useHistory();
    const classes = useStyles();
    const { programInfo, programStatus, programStatusV3, programPaymentStatus } = data;
    const { showPdfReportAction, signUpAction, downloadBadgeAction, accessAssessmentAction } = actions;
    const { isGuestUser,programId } = options;

    const handleShowPdfReport = () => {
        showPdfReportAction();
    }

    return (
        <>
            <Box sx={{ backgroundColor:'#F4EEEE', padding:{sm:'0px !important', xs:'16px !important'}}}>
                <Typography variant="h3" sx={{ textAlign: "center", marginBottom: 6, paddingTop: 4, marginTop:{xs:'55px', sm:'0px'} }} className={classes.title}>
                    DQ Alignment Summary Report
                </Typography>

                <Grid container sx={{display:'flex',justifyContent:'center'}}>
                    <Grid item
                          xs={12}
                          sm={4}
                          sx={{display: "flex", flexDirection: "column",marginRight: {sm:'15px'}, padding: "0 30px",alignItems:'center',borderRadius:'15px', gap: 3, backgroundColor:'#FFFF',
                    }}>
                        <Typography variant="h6" sx={{ marginTop: 5 }} className={classes.title}>Your DQ Alignment</Typography>
                        {/*<Box*/}
                        {/*    component="img"*/}
                        {/*    src={Logo}*/}
                        {/*    alt="Logo"*/}
                        {/*    sx={{ width: "180px", alignSelf: "center", }}*/}
                        {/*/>*/}
                        <Box sx={{ display: "flex", justifyContent: "center", marginBottom: 2 }}>
                            <Rating
                                value={2}
                                max={3}
                                readOnly
                                icon={<span style={{ color: "#FFD700", fontSize: "80px" }}>★</span>}
                                emptyIcon={<span style={{ color: "#E0E0E0", fontSize: "80px" }}>★</span>}
                            />
                        </Box>
                        <Typography variant="h5" gutterBottom sx={{fontWeight:'bold',textAlign:'center',padding: "0 25px",}}>
                            Congratulations on achieving <br/>
                            the DQ Alignment!
                        </Typography>
                        <Typography sx={{padding: "0 25px",}}>
                            Your program empowers learners with intermediate cyber citizenship skills that build confidence, promote well-being, and encourage responsible online behavior.
                            It aligns with Cyber Safety Management and Cyber Civility from the Cyber Citizenship Framework. It excels in delivering practical skills with a focus on personal
                            and online well-being, thereby adopting a holistic approach to digital citizenship.
                        </Typography>
                        <Typography sx={{padding: "0 25px",fontStyle:'italic'}}>
                            This alignment showcases your alignment to DQ’s Cyber Citizenship Framework based on the IEEE DQ Global Standards (IEEE3527.1 <sup>TM</sup>).
                        </Typography>
                        <Button
                            variant="contained"
                            className={classes.badgeButton}
                            onClick={() => {
                                if (isGuestUser) {
                                    signUpAction();
                                } else {
                                    downloadBadgeAction();
                                }
                            }}>
                            Download Badge
                        </Button>
                    </Grid>

                    {/* Right Section */}
                    <Grid item xs={12}
                          sm={7}
                          sx={{display: "flex", flexDirection: "column", alignItems:'center',marginTop:{sm:'0px',xs:'25px'}, gap: 3,backgroundColor:'#FFFF',borderRadius:'15px', paddingBottom:'30px'
                    }}>
                        <Typography variant="h4" style={{fontSize: '35px !important', fontWeight:'bold', textAlign: 'center',}} sx={{ marginTop: '55px' }}>About Your Program</Typography>
                        <Box sx={{ display: "flex",flexDirection: { xs: "column", sm: "row" }, gap: 2, width:'90%' }}>
                            {programInfo.map((item, index) => (
                                <Card
                                    key={index}
                                    sx={{
                                        padding: 2,
                                        flex: 1,
                                        backgroundColor: "#F5F5F5",
                                        textAlign: "center",
                                    }}
                                >
                                    <Typography variant="subtitle1" style={{fontWeight:'bold', color:'#ED6628', marginBottom:'10px'}}>{item.title}</Typography>
                                    <Typography variant="body2" style={{marginTop:'auto'}}>{item.value}</Typography>
                                </Card>
                            ))}
                        </Box>
                       <Grid item  sx={{display: "flex", flexDirection: "column", alignItems:'center', paddingLeft:'15px', }}>
                           <Grid>
                                   <Typography
                                       variant="h6"
                                       sx={{ fontWeight: 'bold', marginBottom: '8px',padding:'0 15px' , width:'100%' }}
                                   >
                                       A. What cyber-risks can my program reduce?
                                   </Typography>
                                   <Typography
                                       variant="body1"
                                       sx={{ marginBottom: '16px',padding:'0 15px' }}
                                   >
                                       Based on your program’s content, your program could possibly reduce certain children’s cyber-risks. You can also potentially red                                   </Typography>
                                <Typography  variant="h6" sx={{ marginTop: 3, padding:{sm:'10px 0px 10px 50px', xs:'10px 0px 10px 10px'}, fontWeight:'bold', }} style={{
                                    textAlign:'left',}}>
                                    Cyber-Risks Your Program Can Reduce Potentially by 15%                                </Typography>
                               <Box sx={{display:'flex', flexDirection:{sm:'row', xs:'column'}, alignItems:'center'}}>
                                <Box component="ul" sx={{padding:{sm:'10px 0px 10px 60px', xs:'10px 0px 10px 10px'}}} style={{textAlign:'left', width:'85%'}}>
                                    <Typography component="li" style={{fontWeight:'bold',}}>
                                        Excessive Screen Time
                                    </Typography>
                                    <Typography component="li" style={{fontWeight:'bold',}}>
                                        Video Game Disorder
                                    </Typography>
                                    <Typography component="li" style={{fontWeight:'bold', color:'#ea516b', textDecoration:'underline'}}>
                                        Get Full Report to See What Other Cyber-Risks Your Program Covers
                                    </Typography>
                                </Box>
                                <Box sx={{marginRight:3, width:{sm:'30%', xs:'60%'}}}>
                                   <Button disabled={programStatusV3 < APP_STATUS.PROGRAM_FULL_REPORT_COMPLETED} className={classes.badgeButton} style={{width:'175px', lineHeight:'18px'}} variant="contained" color="primary" sx={{ marginLeft: '16px' }}
                                           onClick={() => {
                                               if (isGuestUser) {
                                                   signUpAction(`/rating/${programId}/select_assessment`);
                                               } else {
                                                   accessAssessmentAction(programStatus);
                                               }
                                           }}
                                   >
                                       Measure <br/>
                                       Program Impact
                                   </Button>
                               </Box>
                               </Box>
                               <Divider
                                   sx={{
                                       marginY: 2,
                                       borderColor: 'rgba(0, 0, 0, 0.1)',
                                       borderWidth: '1px',
                                       borderStyle: 'solid'
                                   }}
                               />
                      </Grid>

                    <Grid>
                           <Typography
                               variant="h6"
                               sx={{ fontWeight: 'bold', marginBottom: '8px',textAlign:'left',padding:'0 15px' , width:'100%' }}
                           >
                               B. What cyber citizenship competencies does my program align with?
                           </Typography>
                           <Typography
                               variant="body1"
                               sx={{ marginBottom: '16px', padding:'0 15px' }}
                           >
                               Based on your program’s content, students can enhance their mental health and foster positive behavior changes through the cyber citizenship competencies taught by your program.
                           </Typography>
                        <Typography variant="h6" sx={{padding:{sm:'10px 0px 10px 50px', xs:'10px 0px 10px 10px'}}} style={{
                            fontWeight:'bold',
                            textAlign:'left',}}
                        >
                            Cyber Citizenship Competencies Your Program Covers
                        </Typography>
                          <Box sx={{display:'flex', flexDirection:{sm:'row', xs:'column'}, alignItems:'center'}}>
                            <Box component="ul" sx={{padding:{sm:'10px 0px 10px 60px', xs:'10px 0px 10px 10px'}}} style={{width:'85%', textAlign:'left'}}>
                                <Typography component="li" style={{fontWeight:'bold',}}>
                                    <strong style={{ color: "#ED6628" }}>100% Aligned</strong> - Building ICT Literacy and Digital Fluency
                                </Typography>
                                <Typography component="li" style={{fontWeight:'bold',}}>
                                    <strong style={{ color: "#ED6628", }}>87% Aligned</strong> - Managing Personal Cyber Threats
                                </Typography>
                                <Typography component="li" style={{fontWeight:'bold',color:'#ea516b', textDecoration:'underline'}}>
                                    Get Full Report to See What Else You Are Aligned With
                                </Typography>
                            </Box>
                        <Box sx={{marginRight:3,  width:{sm:'30%', xs:'60%'},}}>
                            <Button className={classes.badgeButton} style={{width:'175px', lineHeight:'18px'}} variant="contained" color="primary" sx={{ marginLeft: '16px' }}
                                    onClick={() => isGuestUser ? signUpAction() : handleShowPdfReport()}>
                                {programPaymentStatus < APP_STATUS.COMPLETED ? (
                                    <>
                                        PURCHASE <br /> Full Report
                                    </>
                                ) : (
                                    <>
                                        SHOW <br /> Full Report
                                    </>
                                )}
                            </Button>
                        </Box>
                      </Box>
                      <Divider
                        sx={{marginY: 2, borderColor: 'rgba(0, 0, 0, 0.1)', borderWidth: '1px', borderStyle: 'solid'}}/>
                    </Grid>

                    <Grid>
                           <Typography
                               variant="h6"
                               sx={{ fontWeight: 'bold', marginBottom: '8px',padding:'0 15px' , width:'100%' }}
                           >
                               C. What cyber citizenship competencies can I enhance to be aligned?
                           </Typography>
                           <Typography
                               variant="body1"
                               sx={{ marginBottom: '16px',padding:'0 15px' }}
                           >
                               Based on your program’s content and current coverage, you could enhance the following competencies to get alignment.                           </Typography>
                        <Typography variant="h6" sx={{padding:{sm:'10px 0px 10px 50px', xs:'10px 0px 10px 10px'}}}  style={{
                            fontWeight:'bold',
                            textAlign:'left'}}>Cyber Citizenship Competencies Your Program Could Enhance</Typography>
                        <Box sx={{display:'flex', flexDirection:{sm:'row', xs:'column'}, alignItems:'center'}}>
                            <Box sx={{padding:{sm:'10px 0px 10px 60px', xs:'10px 0px 10px 10px'}}}
                                style={{ width: '85%', fontWeight: 'bold', listStyleType: 'disc',}}
                                component="ul"
                            >
                                <Typography component="li" style={{ fontWeight: 'bold' }}>
                                    <strong style={{ color: "#ED6628" }}>34% Aligned</strong> - Managing Cyberbullying
                                </Typography>
                                <Typography component="li" style={{ fontWeight: 'bold' }}>
                                    <strong style={{ color: "#ED6628" }}>27% Aligned</strong> - Managing Contact Risks
                                </Typography>
                                <Typography component="li" style={{ fontWeight: 'bold', color: '#ea516b', textDecoration: 'underline' }}>
                                    Get Full Report to See Other Competencies Your Program Can Easily Enhance
                                </Typography>
                            </Box>
                            <Box sx={{marginRight:3 ,width:{sm:'30%', xs:'60%'},}}>
                                <Button className={classes.badgeButton} style={{width:'175px', lineHeight:'18px'}} variant="contained" color="primary" sx={{ marginLeft: '16px' }}
                                        onClick={() => isGuestUser ? signUpAction() : handleShowPdfReport()}>
                                    ENHANCE <br /> PROGRAM CONTENT
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                 </Grid>
                </Grid>
                </Grid>
            </Box>
        </>
    );
}

export default DQRatingContentReport;
